<template>
  <div id="scrEnd" class="align">
    <IconBase viewBox="0 0 68 68">
      <icon></icon>
    </IconBase>
    <p class="ln1">Спасибо!</p>
    <p class="ln2">Ваша заявка была предварительно одобрена.</p>
<!--    <p class="ln2">Через несколько секунды вы будете отправлены в личный кабинет</p>-->

    <div class ='flex'>
      <div class="select1" v-if="system.DealProductType">
        <p class="cn1">Перейти в личный кабинет и отслеживать статус вашей заявки</p>
        <button v-on:click.prevent="gotoLk('DealProductType')">Перейти в личный кабинет</button>
      </div>
      <p class='or' v-if="system.isPDL">ИЛИ</p>
      <div class="select1" v-if="system.isPDL">
        <p class="cn1">Получить деньги прямо сейчас</p>
        <button v-on:click.prevent="gotoLk('isPDL')">Получить до 15.000₽</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters} from 'vuex';

  export default {
    name: "loanThanks",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      icon: () => import('@/components/svg/icon'),
    },
    methods:{
        showsrcEnd(){
            this.$store.commit("showThanks")
        },
        gotoLk(type){
          let report;
            if (type == 'isPDL'){
               report = {
                isPDL:true,
                DealProductType:false,
              }
            } else {
               report = {
                isPDL:false,
                DealProductType:true,
              }
            }
            this.$myApi.SendRequest({
              action:'SetDecision',
              demID:this.system.loanDemandId,
              DecTxt:report
            }).then(res=>{
              console.log(res);
            }).catch(res=>{
              console.log(res);
            }).finally(()=>{
              document.location.href='https://lk.msk.finmoll.com/pdl/entering?demand=' + this.system.loanDemandId +
                '&isPDL=' + report.isPDL +'&loanId=' + this.system.loanid + '&session=' +  window.session_id;
            });
        },
        designStart(){
          this.$store.dispatch('showLoading');
          // let startTime =  (this.canPdl) ? 120000: 30000;
          let startTime =   30000;
          this.$store.dispatch('getResultLoan',{time:startTime, i: 0})
          .then((res)=>{
            this.$palantir.trackAction(145,JSON.stringify(res));
            if (res.isPDL == 'false' && res.DealProductType == 'false') {
              this.$store.dispatch('formRouting', 'scrEnd');
            }
            if (res.isPDL == 'true' && this.canPdl) {
              if (window.ym) {
                // eslint-disable-next-line no-undef
                ym(51632228, 'reachGoal', 'admdPdl');
              }
              this.gotoLk('isPDL');
            } else if (res.DealProductType == 'true') {
              this.gotoLk('DealProductType');
            } else {
              document.location.href = window.linkToMarket;
              this.$store.dispatch('formRouting', 'scrEndError');
              this.$store.dispatch('hideLoading');
            }
          }).catch((res)=>{
            this.$palantir.trackAction(144,JSON.stringify(res));
            let redirect = true;
            try {
              if (res.Response.ExecutionError.ExecutionErrorCode != undefined &&
                res.Response.ExecutionError.ExecutionErrorCode == 1) {
                redirect = false;
                this.designStart();
              }
            } catch (e) {
              this.$palantir.trackAction(144,JSON.stringify(e));
            }
            if (redirect) {
              document.location.href = window.linkToMarket;
              this.$store.dispatch('formRouting', 'scrEndError');
              this.$store.dispatch('hideLoading');
            }
          }).finally(()=>{

          });
        }
    },
    computed:{
      ...mapState({
        system:(state)=>state.Form.system,

      }),
      ...mapGetters([
        'getRedirectUrl',
        'canPdl'
      ]),
    },
    mounted(){
      if (window.ym) {
        // eslint-disable-next-line no-undef
        ym(51632228, 'reachGoal', 'admdPdlSms');
      }

         this.designStart();

      window.scrollTo({
        left:0,
        top:this.$parent.$refs.formAlign.offsetTop - 400,
        behavior: 'smooth'
      });
    }
  }
</script>

<style scoped>
  #scrEnd{text-align: center;padding: 15vw 0;background: white;}
  svg{width: 22vw;height: 22vw;}
.ln1{font-size: 7vw;font-weight: bold;padding-top: 8vw;}
.ln2{font-size: 5.6vw;padding: 2vw 0;}
.or{font-weight:bold;}
.flex{padding-top: 7vw;width: 68vw;margin-left: auto; margin-right: auto;}
.or{padding: 7vw 0 7vw;}
.cn1{padding-bottom: 4vw;}
@media screen and (min-width: 760px) {
  #scrEnd{padding: 4vw 0 8vw;}
  svg{width: 6vw;height: 6vw;}
  .ln1{font-size: 2vw;padding-top: 3vw;}
  .ln2{font-size: 1.6vw;padding: 1vw 0;}
  .flex{width: 100%;display: flex; justify-content: space-around; padding-top: 5vw;align-items: flex-end;}
  .cn1{width:30vw;font-size: 1.6vw; padding-bottom:3vw;}
  .or{align-self: flex-start;padding:0;}

}
@media screen and (min-width: 1140px) {
  #scrEnd{padding: 40px 0;}
  svg{width: 68px;height: 68px;}
  .ln1{font-size: 22px;padding-top: 40px;}
  .ln2{font-size: 18px;padding: 15px 0;}
  .cn1{width: 335px; font-size: 18px;padding-bottom: 38px;}
  .flex{padding-top: 16px;width: 100%;}
  .or{font-size: 21px; padding-top: 116px;}

}
</style>
